module.exports = __webpack_public_path__ + "img/help-button.d6c0ad73.svg";